/**
 * Reload the page. A module of its own so a test can see the reload was asked
 * for, which jsdom cannot carry out.
 */
export const reloadPage = (): void => {
	window.location.reload();
};
